// module cache are used so entry inlining is disabled
// startup
// Load entry module and return exports
__webpack_require__("./node_modules/.pnpm/@umijs+react-refresh-webpac_b0e69e45e1b60e0518e48ce0503c7424/node_modules/@umijs/react-refresh-webpack-plugin/client/ReactRefreshEntry.js");
var __webpack_exports__ = __webpack_require__("./mfsu-virtual-entry/umi.js");
